import React from 'react';
import { useAccountInformation } from '../../contexts/AccountInformationContext';
import { formatDate } from '../../utils/formatDates';
import Button from '@mui/material/Button';
import useTranslate from '../../customHooks/useTranslate';
import useLanguage from '../../customHooks/useLanguage';
import useTimeZone from '../../customHooks/useTimeZone';

const TermsAndConditionsAcceptedInfo = props => {
    const { handleOpenPopUp } = props;
    const { accountInfo } = useAccountInformation();
    const language = useLanguage();
    const timeZone = useTimeZone();

    const dateSigned = formatDate(accountInfo.DateSigned, language, timeZone);
    return (
        <>
            {`${'Fastpayhotels'} `}
            <Button
                href='#text-buttons'
                className='viewPopUp__button'
                onClick={handleOpenPopUp}
            >
                {useTranslate('terms_and_conditions')}
            </Button>
            {`${useTranslate('accepted_on')} `}
            {dateSigned}
        </>
    );
};

export default TermsAndConditionsAcceptedInfo;
